import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Modal, Table } from 'semantic-ui-react';
import clsx from 'clsx';
import { columnName, columnValidTo } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import DeleteOrCancel from '@/components/buttons/DeleteOrCancel';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import TableWrapper from '@/components/table/TableWrapper';
import { disableToken, hideDisableToken } from '../actions';
import TokensTableColumns from './TokensTableColumns';
import TokensTableRows from './TokensTableRows';

const TokenDisableDialog = ({
  category,
  disableData,
  hide,
  results,
  theme,
}) => {
  const intl = useIntl();
  const tokenName = () => (results.length === 1 ? results[0].name : null);

  const modalSize = () => (results.length === 1 ? 'tiny' : 'small');

  const disableText = () => (results.length === 1 ? 'token.disable.button' : 'tokens.disable.button');

  const titleText = () => (results.length === 1
    ? intl.formatMessage({ id: 'token.disable.title' })
    : intl.formatMessage({ id: 'tokens.disable.title' }));

  const saving = () => results.some((result) => result.disableStatus === states.PENDING);

  return (
    <DialogWrapper
      className={clsx('aridhia-token-deletion-dialog', { smallwizard: results.length > 1 })}
      icon="wait"
      message={results.length === 1 ? 'token.disable.text' : 'tokens.disable.text'}
      messageIcon="warning circle"
      onClose={hide}
      size={modalSize()}
      theme={theme}
      title={titleText()}
      values={{ name: `'${tokenName()}'` }}
      warning
    >
      <Modal.Content scrolling>
        {results.length > 1 && (
        <div className="aridhia-token-dialog-table">
          <TableWrapper sticky celled className="aridhia-Tokens-table">
            <Table.Header>
              <TokensTableColumns items={results} columns={[columnName, columnValidTo]} />
            </Table.Header>
            <Table.Body>
              <TokensTableRows items={results} columns={[columnName, columnValidTo]} />
            </Table.Body>
          </TableWrapper>
        </div>
        )}
      </Modal.Content>
      <DeleteOrCancel
        deleteMessageId={disableText()}
        inProgress={saving()}
        minimumDataEntryMet
        onClose={hide}
        onDelete={() => disableData(results, category)}
      />
    </DialogWrapper>
  );
};

const mapStateToProps = ({
  tokens: { tokens: { batch: { results } }, disableTokenCategory },
}) => ({
  category: disableTokenCategory,
  results,
});

const mapDispatchToProps = {
  hide: hideDisableToken,
  disableData: disableToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenDisableDialog);
